import React from "react";
import styled from "styled-components/macro";
import { spacing } from "@material-ui/system";
import {
  AppBar,
  Button as MuiButton,
  Container,
  Grid,
  isWidthDown,
  Toolbar,
  Tooltip,
  withWidth,
} from "@material-ui/core";

import { Link as MuiLink } from "@material-ui/core";
import { useAuth0 } from "@auth0/auth0-react";

const Button = styled(MuiButton)(spacing);

const BrandIcon = styled.img`
  margin-right: ${(props) => props.theme.spacing(2)}px;
  display: flex;
  align-items: center;
`;

function AppBarComponent({ width }) {
  const { loginWithRedirect } = useAuth0();
  return (
    <AppBar position="absolute" color="transparent" elevation={0}>
      <Toolbar>
        <Container>
          <Grid container alignItems="center">
            <Grid item>
              <MuiLink
                href="https://lrewater.com"
                target="_blank"
                rel="noreferrer noopener"
              >
                <Tooltip title="Built by LRE Water">
                  <BrandIcon
                    src={`/static/img/lrewater-logo-simple.svg`}
                    width={isWidthDown("xs", width) ? "125" : "150"}
                    height={isWidthDown("xs", width) ? "40" : "48"}
                    alt={"LREWater.com"}
                  />
                </Tooltip>
              </MuiLink>
            </Grid>

            <Grid item xs />
            <Grid item>
              <Button
                ml={2}
                color="primary"
                variant="contained"
                onClick={() => {
                  localStorage.setItem("loginInitiated", "true");
                  loginWithRedirect().then();
                }}
              >
                {isWidthDown("xs", width) ? "Dashboard" : "View Dashboard"}
              </Button>
            </Grid>
          </Grid>
        </Container>
      </Toolbar>
    </AppBar>
  );
}

export default withWidth()(AppBarComponent);
